import React from "react";
import LegalPage from "./LegalPage";
import { privacyContent } from "./legalContent";

/**
 * /privacy — the GDPR art. 13 information notice.
 *
 * No version number: this is an information notice, not something the user
 * accepts, so there is nothing to prove agreement to. Only the Terms are
 * versioned and stored against the account.
 */
const Privacy = () => <LegalPage content={privacyContent} />;

export default Privacy;
